import React from 'react';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Hamburger = _ref => {
  let {
    id = "",
    className = "",
    style = {},
    opened = false,
    onMenuClick = () => {}
  } = _ref;
  const hamburgerContainerClass = cn('flex flex-col justify-center items-center cursor-pointer', className);
  const barClass = "w-6 h-0.5 bg-white mb-1 last:mb-0 transition-transform duration-500";
  const bar1Class = cn(barClass, {
    'transform rotate-45 translate-y-2': opened,
    'mt-1': true
  });
  const bar2Class = cn(barClass, {
    'opacity-0': opened
  });
  const bar3Class = cn(barClass, {
    'transform -rotate-45 -translate-y-1': opened
  });
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: hamburgerContainerClass,
    onClick: onMenuClick,
    role: "button",
    tabIndex: 0,
    style: style,
    "aria-label": "Menu",
    "aria-expanded": opened,
    children: [/*#__PURE__*/_jsx("div", {
      className: bar1Class
    }), /*#__PURE__*/_jsx("div", {
      className: bar2Class
    }), /*#__PURE__*/_jsx("div", {
      className: bar3Class
    })]
  });
};
Hamburger.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  opened: PropTypes.bool,
  onMenuClick: PropTypes.func
};
export default Hamburger;
//# sourceMappingURL=Hamburger.js.map